// import { api } from 'app/config/apiConfig';
// import { InternalEquipment } from '../model/types';
//
// export const accessibleDoorsApi = api.injectEndpoints({
//   endpoints: (builder) => ({
//     getAccessibleDoors: builder.query<InternalEquipment[], { warehouseId: string }>({
//       query: ({ warehouseId }) => ({
//         url: `/warehouses/${warehouseId}/zones/accessible-doors`,
//       }),
//       providesTags: ['Zones', 'Warehouses'],
//     }),
//   }),
// });
//
// export const { useGetAccessibleDoorsQuery } = accessibleDoorsApi;
//

import { api } from 'app/config/apiConfig';
import { InternalEquipment } from '../model/types';

export const accessibleDoorsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAccessibleDoors: build.query<InternalEquipment[], Nullable<string>>({
      query: (warehouseId) => ({
        url: `/warehouses/${warehouseId}/zones/accessible-doors`,
      }),
    }),
  }),
});

export const { useGetAccessibleDoorsQuery } = accessibleDoorsApi;
